import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as NavActions from './shipments.nav.actions';

export const initialState = {
  searchData: {
    searchTerm: '',
  },
  searchPerformed: false,
};

const handleViewSearch = (state, action) => {
  if (!action.searchData) {
    return state;
  }
  return {
    ...state,
    searchData: action.searchData,
    searchPerformed: true,
  };
};

const actionHandlerMap = {
  [NavActions.SHIPMENTS_SEARCH]: handleViewSearch,
  [NavActions.SHIPMENTS_SET_SEARCH_PERFORMED]: (state, { wasSearchPerformed }) => {
    return {
      ...state,
      searchPerformed: wasSearchPerformed,
    };
  },
  [NavActions.CLEAR_SEARCH_INPUT]: (state) => {
    return {
      ...state,
      searchData: Object.assign({}, state.searchData, { searchTerm: '' }),
      searchPerformed: false,
      selected: false,
    };
  },
  [NavActions.SHIPPING_SEARCH_TERM_CHANGE]: (state, action) => {
    return {
      ...state,
      searchData: Object.assign({}, state.searchData, {
        searchTerm: action.searchValue,
      }),
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './shipments.nav.reducer.metadata';
